import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

interface GetConversationStatsParams {
	startDate?: string
	endDate?: string
	client?: string
}
export interface GetConversationStatsResponse {
	UIC: number
	BIC: number
	FTC: number
	FEP: number
}
export const getConversationStats = async (
	params: GetConversationStatsParams
): Promise<GetConversationStatsResponse> => {
	try {
		const { data } = await axios.get('v1/conversation/management/bic-uic/stats', {
			params,
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}
export default getConversationStats
